// Map

const markerSymbol = {
  "path": `M27.5,13.8C27.5,6.2,21.3,0,13.8,0C6.2,0,0,6.2,0,13.8c0,6.9,5.2,12.8,12,13.6v10.1c-1.2,0.6-2,1.9-2,3.3
  c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-1.4-0.8-2.7-2-3.3V27.4C22.3,26.5,27.5,20.7,27.5,13.8z M13.8,10.5
  c1.8,0,3.2,1.5,3.2,3.2S15.5,17,13.8,17s-3.2-1.5-3.2-3.2S12,10.5,13.8,10.5z`,
  "fillColor": "#000000",
  "fillOpacity": 1,
  "anchor": { "x": 13.75, "y": 41 },
  "strokeColor": "#ffffff",
  "strokeWeight": 1.5
}
const activeMarkerSymbol = {
  "path": `M4,37.184V0H2v37.184C0.839,37.598,0,38.698,0,40c0,1.654,1.346,3,3,3s3-1.346,3-3
  C6,38.698,5.161,37.598,4,37.184z`,
  "fillColor": "#EBB123",
  "fillOpacity": 1,
  "anchor": { "x": 3, "y": 40 },
  "strokeOpacity": 0
}

window.markerClick = function (mapId, markerId, fillColor = '#000000') {
  const map = googleMaps.getMap(mapId);
  const marker = map.getMarker(markerId);

  // track which marker is active on the current map
  map.activeMarker = map.activeMarker || null;

  // Don't do anything if the same marker was clicked again
  if (map.activeMarker != marker) {
    const infoWindow = map.getInfoWindow(markerId);

    // If there's an active marker, reset it's icon
    if (map.activeMarker) {
      markerSymbol.fillColor = map.activeMarker.fillColor;
      map.activeMarker.setIcon(markerSymbol)
    }

    // Change icon for the clicked marker
    marker.setIcon(activeMarkerSymbol);

    // Reset event listeners for the info window so we don't
    // add more than one
    google.maps.event.clearInstanceListeners(infoWindow);

    // Then add a new event listener for closing the info window
    // that resets the marker
    google.maps.event.addListenerOnce(infoWindow, "closeclick", () => {
      markerSymbol.fillColor = fillColor;
      marker.setIcon(markerSymbol);
      map.activeMarker = null;
    });

    map.activeMarker = marker;
    map.activeMarker.fillColor = fillColor;
  }
}
